// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `label {
  font-size: 1.4rem;
  line-height: 1.7rem;
  color: var(--black);
  display: flex;
  align-items: center;
  cursor: pointer;
}
label input {
  display: none;
}
label .chip .indicator {
  display: none;
}
label.invalid .indicator {
  border: 0.1rem solid var(--red);
}
label .indicator {
  width: 1.8rem;
  height: 1.8rem;
  border: 0.1rem solid var(--radio-border);
  border-radius: 50%;
  margin-right: 1.2rem;
  display: block;
  position: relative;
  transition: border-color 0.2s;
}
label .indicator:after {
  content: "";
  width: 1.2rem;
  height: 1.2rem;
  background: var(--radio-main);
  border-radius: 50%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  transition: background 0.2s;
}
label:hover .indicator {
  border-color: var(--primary);
}
label input:checked + .indicator {
  border-color: var(--primary);
}
label input:checked + .indicator:after {
  background: var(--primary);
}
label.chip {
  width: max-content;
  height: 3.2rem;
  font-size: 1.4rem;
  line-height: 1.7rem;
  color: var(--grey-icon);
  padding: 0 1.5rem;
  border: 0.1rem solid var(--grey-icon);
  border-radius: 3rem;
  display: flex;
  align-items: center;
  transition: color 0.3s, background 0.3s, border-color 0.3s;
  cursor: pointer;
}
label.chip:hover {
  color: var(--primary-30);
  border-color: var(--primary-30);
}
label.chip.selected {
  color: var(--white);
  background: var(--primary);
  border-color: var(--primary);
}
label.chip.warn {
  background: var(--orange-light-secondary);
  border-color: var(--orange-secondary);
}`, "",{"version":3,"sources":["webpack://./src/shared/radio/radio.component.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;AACF;AACE;EACE,aAAA;AACJ;AAEE;EACE,aAAA;AAAJ;AAII;EACE,+BAAA;AAFN;AAME;EACE,aAAA;EACA,cAAA;EACA,wCAAA;EACA,kBAAA;EACA,oBAAA;EACA,cAAA;EACA,kBAAA;EACA,6BAAA;AAJJ;AAMI;EACE,WAAA;EACA,aAAA;EACA,cAAA;EACA,6BAAA;EACA,kBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,2BAAA;AAJN;AAUI;EACE,4BAAA;AARN;AAYE;EACE,4BAAA;AAVJ;AAYI;EACE,0BAAA;AAVN;AAcE;EACE,kBAAA;EACA,cAAA;EACA,iBAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,qCAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,0DACE;EAGF,eAAA;AAfJ;AAiBI;EACE,wBAAA;EACA,+BAAA;AAfN;AAkBI;EACE,mBAAA;EACA,0BAAA;EACA,4BAAA;AAhBN;AAmBI;EACE,yCAAA;EACA,qCAAA;AAjBN","sourcesContent":["label {\n  font-size: 1.4rem;\n  line-height: 1.7rem;\n  color: var(--black);\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n\n  & input {\n    display: none;\n  }\n\n  & .chip .indicator {\n    display: none;\n  }\n\n  &.invalid {\n    & .indicator {\n      border: 0.1rem solid var(--red);\n    }\n  }\n\n  & .indicator {\n    width: 1.8rem;\n    height: 1.8rem;\n    border: 0.1rem solid var(--radio-border);\n    border-radius: 50%;\n    margin-right: 1.2rem;\n    display: block;\n    position: relative;\n    transition: border-color 0.2s;\n\n    &:after {\n      content: '';\n      width: 1.2rem;\n      height: 1.2rem;\n      background: var(--radio-main);\n      border-radius: 50%;\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      transform: translate(-50%, -50%);\n      transition: background 0.2s;\n    }\n\n  }\n\n  &:hover {\n    & .indicator {\n      border-color: var(--primary);\n    }\n  }\n\n  & input:checked+.indicator {\n    border-color: var(--primary);\n\n    &:after {\n      background: var(--primary);\n    }\n  }\n\n  &.chip {\n    width: max-content;\n    height: 3.2rem;\n    font-size: 1.4rem;\n    line-height: 1.7rem;\n    color: var(--grey-icon);\n    padding: 0 1.5rem;\n    border: 0.1rem solid var(--grey-icon);\n    border-radius: 3rem;\n    display: flex;\n    align-items: center;\n    transition:\n      color 0.3s,\n      background 0.3s,\n      border-color 0.3s;\n    cursor: pointer;\n\n    &:hover {\n      color: var(--primary-30);\n      border-color: var(--primary-30);\n    }\n\n    &.selected {\n      color: var(--white);\n      background: var(--primary);\n      border-color: var(--primary);\n    }\n\n    &.warn {\n      background: var(--orange-light-secondary);\n      border-color: var(--orange-secondary);\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
